<template>
  <div :class="clazz">
    <button
      :type="buttonType"
      :disabled="isNativeDisabled"
      :aria-disabled="isUnavailable ? 'true' : undefined"
      :aria-busy="busy ? 'true' : undefined"
      :class="'d-flex flex-row align-items-center pointer button_' + variant + ' w-auto f16-l10 df18-l10 dbutton'"
      :style="{ padding: '0 16px', opacity: isUnavailable ? 0.6 : undefined, cursor: isUnavailable ? 'not-allowed' : undefined }"
      @click="handleClick"
      @keydown="handleKeydown"
    >
      <slot name="right"></slot>
      <slot></slot>
      <span v-if="caption" class="button-content flex-grow-1">{{ caption }}</span>
      <slot name="left"></slot>
    </button>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js'
export default {
  emits: ['click'],
  props: {
    clazz: String,
    caption: String,
    link: String,
    newTab: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "red",
      validator: function (value) {
        return ['red', 'facebook', 'white', 'red_dropdown', 'black', 'link'].includes(value)
      }
    },
    isSubmitButton: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /** When true, button stays focusable (aria-disabled) and announces busy state. */
    busy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonType() {
      return this.isSubmitButton ? 'submit' : 'button'
    },
    isUnavailable() {
      return this.disabled || this.busy
    },
    // Native disabled removes focus; skip it while busy so keyboard users keep focus.
    isNativeDisabled() {
      return this.disabled && !this.busy
    }
  },
  methods: {
    handleClick(event) {
      if (this.isUnavailable) {
        event.preventDefault()
        event.stopPropagation()
        return
      }
      this.gotoLink()
      this.$emit('click', event)
    },
    handleKeydown(event) {
      if (!this.isUnavailable) return
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    gotoLink() {
      if (this.variant == 'facebook') {
        this.performFacebookLogin();
        return;
      }

      if (this.link) {
        if (this.newTab) {
          window.open(this.link);
        } else if (this.link.startsWith('#')) {
          window.location = this.link;
        } else if (this.link.startsWith('http')) {
          window.location = this.link;
        } else {
          this.$router.push(this.link);
        }
      }
    },
    performFacebookLogin() {
      // eslint-disable-next-line
      FB.login((response) => {
        if (response.status == 'connected') {
          formSubmit(this, null, window.fbData.login_url, {access_token: response.authResponse.accessToken, vue: 1}).then((res) => {
            if (process.env.NODE_ENV === 'development') {
              console.log(res);
            }
          });
        }
      }, {
        scope: window.fbData.permissions,
      });
    }
  }
}
</script>
<style scoped>
button.dbutton {
  border: none;
  font: inherit;
  appearance: none;
  -webkit-appearance: none;
}

.button_white {
  height: 44px;
  line-height: 44px !important;
  border-radius: 22px;
  border: 1px solid #ef3d49;
  color: #ef3d49;
  background-color: white;
  margin: auto auto;
  text-align: center;
  cursor: pointer;
}

.button_red {
  height: 44px;
  line-height: 44px !important;
  border-radius: 22px;
  background-color: #ef3d49;
  color: white;
  margin: auto auto;
  text-align: center;
  cursor: pointer;
  border-color: #ef3d49;
  border-width: 0px;
}

.button_black {
  height: 44px;
  line-height: 44px !important;
  border-radius: 22px;
  background-color: black;
  color: white;
  margin: auto auto;
  text-align: center;
  cursor: pointer;
  border-color: #ef3d49;
  border-width: 0px;
}

.button_red_dropdown {
  height: 30px;
  line-height: 44px !important;
  border-radius: 22px;
  background-color: #ef3d49;
  color: white;
  margin: auto auto;
  text-align: center;
  cursor: pointer;
  border-color: #ef3d49;
  border-width: 0px;
}

.button_facebook {
  height: 44px;
  line-height: 44px !important;
  border-radius: 22px;
  border: 1px solid #3a67d9;
  color: #3a67d9;
  margin: auto auto;
  text-align: center;
  cursor: pointer;
  background-color: white;
}

.button_facebook:hover {
  background: #3a67d9;
  color: white;
}

.button-content {
  padding: 0 14px;
}

.button_link {
  height: 44px;
  line-height: 44px !important;
  border-radius: 22px;
  background-color: transparent;
  color: #ef3d49;
}
</style>
